/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCategoryProblemBody } from '../models';
// @ts-ignore
import type { CreateCategoryBody } from '../models';
// @ts-ignore
import type { CreateCategoryResponse } from '../models';
// @ts-ignore
import type { CreateProblemBody } from '../models';
// @ts-ignore
import type { CreateProblemResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAdminCategoriesResponse } from '../models';
// @ts-ignore
import type { GetAdminCategoryDetailResponse } from '../models';
// @ts-ignore
import type { GetAdminProblemsResponse } from '../models';
// @ts-ignore
import type { GetCategoriesResponse } from '../models';
// @ts-ignore
import type { GetCategoryDetailResponse } from '../models';
// @ts-ignore
import type { GetLanguagesResponse } from '../models';
// @ts-ignore
import type { GetProblemDetailResponse } from '../models';
// @ts-ignore
import type { GetProblemsResponse } from '../models';
// @ts-ignore
import type { GetResponsesResponse } from '../models';
// @ts-ignore
import type { Message } from '../models';
// @ts-ignore
import type { RunSubmitBody } from '../models';
// @ts-ignore
import type { SubmissionResponse } from '../models';
// @ts-ignore
import type { UnlockHintResponse } from '../models';
// @ts-ignore
import type { UnlockSolutionResponse } from '../models';
// @ts-ignore
import type { UnlockTestCaseResponse } from '../models';
// @ts-ignore
import type { UpdateCategoryBody } from '../models';
/**
 * CodingPracticeApiApi - axios parameter creator
 */
export const CodingPracticeApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} slug 
         * @param {AddCategoryProblemBody} addCategoryProblemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminAddCategoryProblem: async (slug: string, addCategoryProblemBody: AddCategoryProblemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiAdminAddCategoryProblem', 'slug', slug)
            // verify required parameter 'addCategoryProblemBody' is not null or undefined
            assertParamExists('codingPracticeApiAdminAddCategoryProblem', 'addCategoryProblemBody', addCategoryProblemBody)
            const localVarPath = `/coding-practice/admin/categories/{slug}/problems`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCategoryProblemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCategoryBody} createCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminCreateCategory: async (createCategoryBody: CreateCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoryBody' is not null or undefined
            assertParamExists('codingPracticeApiAdminCreateCategory', 'createCategoryBody', createCategoryBody)
            const localVarPath = `/coding-practice/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminGetCategory: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiAdminGetCategory', 'slug', slug)
            const localVarPath = `/coding-practice/admin/categories/{slug}`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminListCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coding-practice/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminListProblems: async (page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coding-practice/admin/problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminRemoveCategoryProblem: async (problemId: string, slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'problemId' is not null or undefined
            assertParamExists('codingPracticeApiAdminRemoveCategoryProblem', 'problemId', problemId)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiAdminRemoveCategoryProblem', 'slug', slug)
            const localVarPath = `/coding-practice/admin/categories/{slug}/problems/{problem_id}`
                .replace('{problem_id}', encodeURIComponent(String(problemId)))
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {UpdateCategoryBody} updateCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminUpdateCategory: async (slug: string, updateCategoryBody: UpdateCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiAdminUpdateCategory', 'slug', slug)
            // verify required parameter 'updateCategoryBody' is not null or undefined
            assertParamExists('codingPracticeApiAdminUpdateCategory', 'updateCategoryBody', updateCategoryBody)
            const localVarPath = `/coding-practice/admin/categories/{slug}`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCategoryBody} createCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiCreateCategory: async (createCategoryBody: CreateCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoryBody' is not null or undefined
            assertParamExists('codingPracticeApiCreateCategory', 'createCategoryBody', createCategoryBody)
            const localVarPath = `/coding-practice/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProblemBody} createProblemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiCreateProblem: async (createProblemBody: CreateProblemBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProblemBody' is not null or undefined
            assertParamExists('codingPracticeApiCreateProblem', 'createProblemBody', createProblemBody)
            const localVarPath = `/coding-practice/problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProblemBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiGetCategory: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiGetCategory', 'slug', slug)
            const localVarPath = `/coding-practice/categories/{slug}`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiGetProblem: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiGetProblem', 'slug', slug)
            const localVarPath = `/coding-practice/problems/{slug}`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiGetSubmission: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('codingPracticeApiGetSubmission', 'submissionId', submissionId)
            const localVarPath = `/coding-practice/submissions/{submission_id}`
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coding-practice/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListLanguages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coding-practice/languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListProblemResponses: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiListProblemResponses', 'slug', slug)
            const localVarPath = `/coding-practice/problems/{slug}/responses`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [difficultyLevel] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListProblems: async (difficultyLevel?: number, page?: number, pageSize?: number, search?: string, tag?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coding-practice/problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (difficultyLevel !== undefined) {
                localVarQueryParameter['difficulty_level'] = difficultyLevel;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {RunSubmitBody} runSubmitBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiRunCode: async (slug: string, runSubmitBody: RunSubmitBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiRunCode', 'slug', slug)
            // verify required parameter 'runSubmitBody' is not null or undefined
            assertParamExists('codingPracticeApiRunCode', 'runSubmitBody', runSubmitBody)
            const localVarPath = `/coding-practice/problems/{slug}/run`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runSubmitBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {RunSubmitBody} runSubmitBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiSubmitCode: async (slug: string, runSubmitBody: RunSubmitBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiSubmitCode', 'slug', slug)
            // verify required parameter 'runSubmitBody' is not null or undefined
            assertParamExists('codingPracticeApiSubmitCode', 'runSubmitBody', runSubmitBody)
            const localVarPath = `/coding-practice/problems/{slug}/submit`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runSubmitBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiUnlockHint: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiUnlockHint', 'slug', slug)
            const localVarPath = `/coding-practice/problems/{slug}/hint/unlock`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiUnlockSolution: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('codingPracticeApiUnlockSolution', 'slug', slug)
            const localVarPath = `/coding-practice/problems/{slug}/solution/unlock`
                .replace('{slug}', encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ordinal 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiUnlockTestcase: async (ordinal: string, submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ordinal' is not null or undefined
            assertParamExists('codingPracticeApiUnlockTestcase', 'ordinal', ordinal)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('codingPracticeApiUnlockTestcase', 'submissionId', submissionId)
            const localVarPath = `/coding-practice/submissions/{submission_id}/testcases/{ordinal}/unlock`
                .replace('{ordinal}', encodeURIComponent(String(ordinal)))
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodingPracticeApiApi - functional programming interface
 */
export const CodingPracticeApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CodingPracticeApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {AddCategoryProblemBody} addCategoryProblemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminAddCategoryProblem(slug: string, addCategoryProblemBody: AddCategoryProblemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminAddCategoryProblem(slug, addCategoryProblemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminAddCategoryProblem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCategoryBody} createCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminCreateCategory(createCategoryBody: CreateCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminCreateCategory(createCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminCreateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminGetCategory(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminCategoryDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminGetCategory(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminGetCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminListCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminListCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminListCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminListProblems(page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminProblemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminListProblems(page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminListProblems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminRemoveCategoryProblem(problemId: string, slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminRemoveCategoryProblem(problemId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminRemoveCategoryProblem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {UpdateCategoryBody} updateCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiAdminUpdateCategory(slug: string, updateCategoryBody: UpdateCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiAdminUpdateCategory(slug, updateCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiAdminUpdateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCategoryBody} createCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiCreateCategory(createCategoryBody: CreateCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiCreateCategory(createCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiCreateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateProblemBody} createProblemBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiCreateProblem(createProblemBody: CreateProblemBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProblemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiCreateProblem(createProblemBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiCreateProblem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiGetCategory(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCategoryDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiGetCategory(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiGetCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiGetProblem(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProblemDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiGetProblem(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiGetProblem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiGetSubmission(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiGetSubmission(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiGetSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiListCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCategoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiListCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiListCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiListLanguages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLanguagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiListLanguages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiListLanguages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiListProblemResponses(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResponsesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiListProblemResponses(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiListProblemResponses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [difficultyLevel] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiListProblems(difficultyLevel?: number, page?: number, pageSize?: number, search?: string, tag?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProblemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiListProblems(difficultyLevel, page, pageSize, search, tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiListProblems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {RunSubmitBody} runSubmitBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiRunCode(slug: string, runSubmitBody: RunSubmitBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiRunCode(slug, runSubmitBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiRunCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {RunSubmitBody} runSubmitBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiSubmitCode(slug: string, runSubmitBody: RunSubmitBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiSubmitCode(slug, runSubmitBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiSubmitCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiUnlockHint(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockHintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiUnlockHint(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiUnlockHint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiUnlockSolution(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockSolutionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiUnlockSolution(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiUnlockSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ordinal 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async codingPracticeApiUnlockTestcase(ordinal: string, submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnlockTestCaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.codingPracticeApiUnlockTestcase(ordinal, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodingPracticeApiApi.codingPracticeApiUnlockTestcase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CodingPracticeApiApi - factory interface
 */
export const CodingPracticeApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CodingPracticeApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiAdminAddCategoryProblemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminAddCategoryProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminAddCategoryProblemRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.codingPracticeApiAdminAddCategoryProblem(requestParameters.slug, requestParameters.addCategoryProblemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiAdminCreateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminCreateCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminCreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCategoryResponse> {
            return localVarFp.codingPracticeApiAdminCreateCategory(requestParameters.createCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiAdminGetCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminGetCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminGetCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminCategoryDetailResponse> {
            return localVarFp.codingPracticeApiAdminGetCategory(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminListCategories(options?: RawAxiosRequestConfig): AxiosPromise<GetAdminCategoriesResponse> {
            return localVarFp.codingPracticeApiAdminListCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiAdminListProblemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminListProblems(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminListProblemsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminProblemsResponse> {
            return localVarFp.codingPracticeApiAdminListProblems(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiAdminRemoveCategoryProblemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminRemoveCategoryProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminRemoveCategoryProblemRequest, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.codingPracticeApiAdminRemoveCategoryProblem(requestParameters.problemId, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiAdminUpdateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiAdminUpdateCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminUpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCategoryResponse> {
            return localVarFp.codingPracticeApiAdminUpdateCategory(requestParameters.slug, requestParameters.updateCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiCreateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiCreateCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiCreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCategoryResponse> {
            return localVarFp.codingPracticeApiCreateCategory(requestParameters.createCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiCreateProblemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiCreateProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiCreateProblemRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateProblemResponse> {
            return localVarFp.codingPracticeApiCreateProblem(requestParameters.createProblemBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiGetCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiGetCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiGetCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCategoryDetailResponse> {
            return localVarFp.codingPracticeApiGetCategory(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiGetProblemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiGetProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiGetProblemRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetProblemDetailResponse> {
            return localVarFp.codingPracticeApiGetProblem(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiGetSubmissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiGetSubmission(requestParameters: CodingPracticeApiApiCodingPracticeApiGetSubmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.codingPracticeApiGetSubmission(requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListCategories(options?: RawAxiosRequestConfig): AxiosPromise<GetCategoriesResponse> {
            return localVarFp.codingPracticeApiListCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListLanguages(options?: RawAxiosRequestConfig): AxiosPromise<GetLanguagesResponse> {
            return localVarFp.codingPracticeApiListLanguages(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiListProblemResponsesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListProblemResponses(requestParameters: CodingPracticeApiApiCodingPracticeApiListProblemResponsesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResponsesResponse> {
            return localVarFp.codingPracticeApiListProblemResponses(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiListProblemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiListProblems(requestParameters: CodingPracticeApiApiCodingPracticeApiListProblemsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetProblemsResponse> {
            return localVarFp.codingPracticeApiListProblems(requestParameters.difficultyLevel, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.tag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiRunCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiRunCode(requestParameters: CodingPracticeApiApiCodingPracticeApiRunCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.codingPracticeApiRunCode(requestParameters.slug, requestParameters.runSubmitBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiSubmitCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiSubmitCode(requestParameters: CodingPracticeApiApiCodingPracticeApiSubmitCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.codingPracticeApiSubmitCode(requestParameters.slug, requestParameters.runSubmitBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiUnlockHintRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiUnlockHint(requestParameters: CodingPracticeApiApiCodingPracticeApiUnlockHintRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnlockHintResponse> {
            return localVarFp.codingPracticeApiUnlockHint(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiUnlockSolutionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiUnlockSolution(requestParameters: CodingPracticeApiApiCodingPracticeApiUnlockSolutionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnlockSolutionResponse> {
            return localVarFp.codingPracticeApiUnlockSolution(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CodingPracticeApiApiCodingPracticeApiUnlockTestcaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        codingPracticeApiUnlockTestcase(requestParameters: CodingPracticeApiApiCodingPracticeApiUnlockTestcaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnlockTestCaseResponse> {
            return localVarFp.codingPracticeApiUnlockTestcase(requestParameters.ordinal, requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for codingPracticeApiAdminAddCategoryProblem operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiAdminAddCategoryProblemRequest {
    readonly slug: string

    readonly addCategoryProblemBody: AddCategoryProblemBody
}

/**
 * Request parameters for codingPracticeApiAdminCreateCategory operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiAdminCreateCategoryRequest {
    readonly createCategoryBody: CreateCategoryBody
}

/**
 * Request parameters for codingPracticeApiAdminGetCategory operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiAdminGetCategoryRequest {
    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiAdminListProblems operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiAdminListProblemsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly search?: string
}

/**
 * Request parameters for codingPracticeApiAdminRemoveCategoryProblem operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiAdminRemoveCategoryProblemRequest {
    readonly problemId: string

    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiAdminUpdateCategory operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiAdminUpdateCategoryRequest {
    readonly slug: string

    readonly updateCategoryBody: UpdateCategoryBody
}

/**
 * Request parameters for codingPracticeApiCreateCategory operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiCreateCategoryRequest {
    readonly createCategoryBody: CreateCategoryBody
}

/**
 * Request parameters for codingPracticeApiCreateProblem operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiCreateProblemRequest {
    readonly createProblemBody: CreateProblemBody
}

/**
 * Request parameters for codingPracticeApiGetCategory operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiGetCategoryRequest {
    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiGetProblem operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiGetProblemRequest {
    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiGetSubmission operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiGetSubmissionRequest {
    readonly submissionId: string
}

/**
 * Request parameters for codingPracticeApiListProblemResponses operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiListProblemResponsesRequest {
    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiListProblems operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiListProblemsRequest {
    readonly difficultyLevel?: number

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string

    readonly tag?: string
}

/**
 * Request parameters for codingPracticeApiRunCode operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiRunCodeRequest {
    readonly slug: string

    readonly runSubmitBody: RunSubmitBody
}

/**
 * Request parameters for codingPracticeApiSubmitCode operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiSubmitCodeRequest {
    readonly slug: string

    readonly runSubmitBody: RunSubmitBody
}

/**
 * Request parameters for codingPracticeApiUnlockHint operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiUnlockHintRequest {
    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiUnlockSolution operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiUnlockSolutionRequest {
    readonly slug: string
}

/**
 * Request parameters for codingPracticeApiUnlockTestcase operation in CodingPracticeApiApi.
 */
export interface CodingPracticeApiApiCodingPracticeApiUnlockTestcaseRequest {
    readonly ordinal: string

    readonly submissionId: string
}

/**
 * CodingPracticeApiApi - object-oriented interface
 */
export class CodingPracticeApiApi extends BaseAPI {
    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiAdminAddCategoryProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminAddCategoryProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminAddCategoryProblemRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminAddCategoryProblem(requestParameters.slug, requestParameters.addCategoryProblemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiAdminCreateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminCreateCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminCreateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminCreateCategory(requestParameters.createCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiAdminGetCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminGetCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminGetCategoryRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminGetCategory(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminListCategories(options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminListCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiAdminListProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminListProblems(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminListProblemsRequest = {}, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminListProblems(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiAdminRemoveCategoryProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminRemoveCategoryProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminRemoveCategoryProblemRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminRemoveCategoryProblem(requestParameters.problemId, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiAdminUpdateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiAdminUpdateCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiAdminUpdateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiAdminUpdateCategory(requestParameters.slug, requestParameters.updateCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiCreateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiCreateCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiCreateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiCreateCategory(requestParameters.createCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiCreateProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiCreateProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiCreateProblemRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiCreateProblem(requestParameters.createProblemBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiGetCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiGetCategory(requestParameters: CodingPracticeApiApiCodingPracticeApiGetCategoryRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiGetCategory(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiGetProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiGetProblem(requestParameters: CodingPracticeApiApiCodingPracticeApiGetProblemRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiGetProblem(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiGetSubmissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiGetSubmission(requestParameters: CodingPracticeApiApiCodingPracticeApiGetSubmissionRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiGetSubmission(requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiListCategories(options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiListCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiListLanguages(options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiListLanguages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiListProblemResponsesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiListProblemResponses(requestParameters: CodingPracticeApiApiCodingPracticeApiListProblemResponsesRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiListProblemResponses(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiListProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiListProblems(requestParameters: CodingPracticeApiApiCodingPracticeApiListProblemsRequest = {}, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiListProblems(requestParameters.difficultyLevel, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiRunCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiRunCode(requestParameters: CodingPracticeApiApiCodingPracticeApiRunCodeRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiRunCode(requestParameters.slug, requestParameters.runSubmitBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiSubmitCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiSubmitCode(requestParameters: CodingPracticeApiApiCodingPracticeApiSubmitCodeRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiSubmitCode(requestParameters.slug, requestParameters.runSubmitBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiUnlockHintRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiUnlockHint(requestParameters: CodingPracticeApiApiCodingPracticeApiUnlockHintRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiUnlockHint(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiUnlockSolutionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiUnlockSolution(requestParameters: CodingPracticeApiApiCodingPracticeApiUnlockSolutionRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiUnlockSolution(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CodingPracticeApiApiCodingPracticeApiUnlockTestcaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public codingPracticeApiUnlockTestcase(requestParameters: CodingPracticeApiApiCodingPracticeApiUnlockTestcaseRequest, options?: RawAxiosRequestConfig) {
        return CodingPracticeApiApiFp(this.configuration).codingPracticeApiUnlockTestcase(requestParameters.ordinal, requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }
}

